import React from 'react';
import { Element } from 'react-scroll';
import Title from './Title';
import Page from '../helpers/Page';
import { getPageId } from '../helpers/utils';
import Stamp from '../../Stamp';
export const Document = ({ id, imagesWidth, pages, actualZoom, setImageBoxHeight, forPrint, onPageComplete, order, showTitle, description, title, stampRef, documentWrapperRef, }) => {
    const pagesBox = pages.map((page, i) => (React.createElement("div", { key: i, className: `image-page ${id}-${i}` },
        React.createElement(Element, { id: getPageId(id, i), name: getPageId(id, i), className: "imageBox" },
            React.createElement("div", { ref: setImageBoxHeight, style: {
                    maxWidth: imagesWidth && imagesWidth > 0 ? 'initial' : '100%',
                } },
                React.createElement(Page, { page: page, pageKey: i, order: order, actualZoom: actualZoom, onPageComplete: onPageComplete, image: false }))))));
    const iframePagesBox = () => pages.map((page, i) => (React.createElement("div", { key: getPageId(id, i), style: {
            maxWidth: imagesWidth && imagesWidth > 0 ? 'initial' : '95%',
        } },
        React.createElement(Page, { page: page, pageKey: i, actualZoom: actualZoom, order: order, image: true, onPageComplete: onPageComplete }))));
    return (React.createElement("div", { id: id, className: "mt-3" },
        !forPrint && showTitle && (React.createElement(Title, { name: title, description: description })),
        forPrint ? (iframePagesBox()) : (React.createElement(React.Fragment, null,
            React.createElement(Element, { name: `doc-${id}`, id: `doc-${id}` }),
            React.createElement("div", { className: "document-pages-wrapper", ref: documentWrapperRef },
                stampRef && React.createElement(Stamp, { className: "drag-drop", stampRef: stampRef }),
                pagesBox)))));
};
export default Document;
